import React, { Component } from 'react';

import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import Modal from '../cosmos/modal';
import { Loader } from '../loader';

import './ConfirmModal.scss';

export default class ConfirmModal extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.shape({
      action: PropTypes.func.isRequired,
      label: PropTypes.string
    }).isRequired,
    onConfirmSecondary: PropTypes.shape({
      action: PropTypes.func.isRequired,
      label: PropTypes.string
    }),
    toggleModal: PropTypes.func
  };

  onCancel = () => {
    const { onCancel, toggleModal } = this.props;

    onCancel?.();
    toggleModal?.();
  };

  renderHeader = () => {
    return (
      <h5 className="_text-4 _text-gray-700 _font-weight-light">
        <I18n label="prevent_leave.header" />
      </h5>
    );
  };

  renderBody = () => {
    return (
      <h6 className="_text-2 _text-gray-500">
        <I18n label="prevent_leave.body" />
      </h6>
    );
  };

  renderFooter = () => {
    const { onConfirmSecondary } = this.props;

    return (
      <div
        className="_w-full _d-flex _flex-column-reverse _flex-sm-row \
        _justify-content-center _justify-content-sm-end _align-items-stretch
        _align-items-center"
      >
        <button
          className="hot-button hot-button--tertiary _mt-2 _mt-sm-0 _mr-0 _mr-sm-2"
          data-test="confirm-secondary"
          onClick={onConfirmSecondary?.action}
        >
          <I18n label={onConfirmSecondary?.label || 'general.ok'} />
        </button>

        <button
          className="hot-button hot-button--primary"
          data-test="cancel-button"
          onClick={this.onCancel}
        >
          <I18n label="prevent_leave.continue" />
        </button>
      </div>
    );
  };

  render() {
    const { loading } = this.props;

    return (
      <Modal
        open
        onClose={this.onCancel}
        header={this.renderHeader()}
        footer={this.renderFooter()}
      >
        {this.renderBody()}
        {loading && <Loader mask />}
      </Modal>
    );
  }
}
